module.exports = __webpack_public_path__ + "media/app/images/background@2x-3987374c6a0d92068f3f6a983fa43c2f.png";